
import styled from "styled-components";


export const StyledMainPageLeftSection = styled.div`
width: 300px;
height: 100%;
background-color: rgba(249, 250, 251, 1);
padding-bottom: 20px;
position: fixed;
top: 80px;
display: flex;
flex-direction: column;
align-items: center;
overflow-y: auto;

gap: 10px;
&::-webkit-scrollbar-button {
    width: 0;
    height: 100%;                     //Not completed the scroll bar design
}
&::-webkit-scrollbar-track {
    background-color: rgba(249, 250, 251, 1);
}
`
export const StyledLeftProfileDisplaySection = styled.div`
width: 256px;
height: 95px;
background-color: #EDEFF2;
border-radius: 12px;
display: flex;
align-items: center;
justify-content: space-between;
padding: 0 8px 0 8px;

`
export const StyledLeftProfileEmonji = styled.div`
width: 50px;
height: 50px;

`
export const StyledLeftProfileNameAndEmail = styled.div`
width: 180px;
height: 60px;


`
export const StyledLeftProfileName = styled.p`
color: black;
`
export const StyledLeftProfileEmail = styled.p`
color: #637380;
font-size: 13px;
`
export const StyledLeftButtonSection = styled.div`
width: 95%;
/* min-height: calc(100vh - 80px); */
min-height: fit-content;
background-color: rgba(249, 250, 251, 1);
border-radius: 12px;
position: absolute;
top:130px ;
padding-top: 10px;
display: flex;
flex-direction: column;
gap: 7px;

`
// export interface IBtn{
//  activateItem : Boolean,
// }

export const StyledLeftSectionButton = styled.button`
width: 256px;
height: 48px;
background-color: ${(props) => props.isActivated ? '#F4F3FF' : '#f9fafb '};// #f9fafb rgba(249, 250, 251, 1);
border: none;
border-radius: 12px;
display: flex;
align-items: center;
gap: 20px;
padding-left: 10px;
color: #637380;
/* &:focus{
    background-color: ${(props) => props.isActivated ? 'red' :''};//#F4F3FF
    
} */
&:hover{
    background-color: #F0F2F4;
    cursor: pointer;
}

`
export const StyledLeftSectionButtonText = styled.p`
font-size: 17px;
color: #637380;
`